import moment from 'moment-timezone';
import { normalizeCalendarView } from './calendarViews';
import { WEEKDAYS } from '../common/Const';
import { buildManageRouteWithSchoolYear } from './manageSchoolYearRouting';

export const getPrincipalKey = (user = {}) => JSON.stringify([
  user.id || null, user.schoolId || null, user.activeContextKey || null,
]);

export function slotToPrefill(start, view, teacherId) {
  const date = moment(start).tz('Europe/Warsaw');
  if (!date.isValid()) return null;
  return {
    teacherId,
    fromDate: date.format('YYYY-MM-DD'),
    dayOfWeek: WEEKDAYS.find(day => day.day === date.day()).id,
    ...(view === 'month' ? {} : { startTime: date.format('HH:mm') }),
  };
}

export function readCreationContext(state, principalKey) {
  const context = state && state.dashboardClassCreation;
  if (!context || context.version !== 1 || context.principalKey !== principalKey) return null;
  const { returnView, prefill, result } = context;
  if (!returnView || !prefill || typeof returnView.teacherId !== 'string' || !returnView.teacherId) return null;
  if (!normalizeCalendarView(returnView.view) || !moment(returnView.date, moment.ISO_8601, true).isValid()) return null;
  if (!Number.isInteger(returnView.schoolYearStartYear) || returnView.schoolYearStartYear < 1900 || returnView.schoolYearStartYear > 9998) return null;
  if (![returnView.pageScrollY, returnView.calendarScrollTop].every(value => Number.isFinite(value) && value >= 0)) return null;
  if (typeof prefill.teacherId !== 'string' || !prefill.teacherId) return null;
  if (prefill.fromDate !== undefined) {
    const date = moment(prefill.fromDate, 'YYYY-MM-DD', true);
    if (!date.isValid() || WEEKDAYS.find(day => day.day === date.day()).id !== prefill.dayOfWeek) return null;
  } else if (prefill.dayOfWeek !== undefined) return null;
  if (prefill.startTime !== undefined && !/^([01]\d|2[0-3]):[0-5]\d$/.test(prefill.startTime)) return null;
  if (result && (result.kind !== 'created' || typeof result.classId !== 'string')) return null;
  return {
    version: 1,
    principalKey,
    returnView,
    prefill: {
      teacherId: prefill.teacherId,
      ...(prefill.fromDate ? { fromDate: prefill.fromDate, dayOfWeek: prefill.dayOfWeek } : {}),
      ...(prefill.startTime ? { startTime: prefill.startTime } : {}),
    },
    ...(result ? { result } : {}),
  };
}

export function buildCreationRoute(context, search) {
  return {
    ...buildManageRouteWithSchoolYear('/manage/class/new', search, context.returnView.schoolYearStartYear),
    state: { dashboardClassCreation: context },
  };
}

export function buildDashboardReturnRoute(context, search, result) {
  return {
    ...buildManageRouteWithSchoolYear('/manage', search, context.returnView.schoolYearStartYear),
    state: { dashboardClassCreation: { ...context, ...(result ? { result } : {}) } },
  };
}
